module.exports = __webpack_public_path__ + "img/20190827144300972.2affa39d.jpg";